$(() => {
  const upfront_fee = () => {
    const number_of_trucks_regional = parseInt($('#number-of-trucks-regional').val().replace(',', ''), 10);
    const number_of_trucks_national = parseInt($('#number-of-trucks-national').val().replace(',', ''), 10);

    return number_of_trucks_regional * 15
      + number_of_trucks_national * 35;
  };

  const run = () => {
    const cost = upfront_fee();

    if ($('#upfront-fee-overridden').val() === '0') {
      $('#upfront-fee').val(accounting.formatMoney(cost, '', 0));
    }
  };

  run();

  $('#number-of-trucks-regional, #number-of-trucks-national').blur(() => {
    run();
  });

  $('#upfront-fee').blur(() => {
    $('#upfront-fee-overridden').val('1');
  });
});
